import { ExcelHelper } from "../ExcelHelper";
import { ServerSyncInfoSettings } from "./ServerSyncInfoSettings";

/**
 * Helps in add and getting the settings from worksheet.
 * https://docs.microsoft.com/en-us/office/dev/add-ins/excel/excel-add-ins-workbooks#access-document-settings
 */
export class DataAddInStateManager {
  // https://docs.microsoft.com/en-us/office/dev/add-ins/excel/excel-add-ins-workbooks#access-document-settings
  public static async persistServerSyncInfoSettings(syncSettings: ServerSyncInfoSettings): Promise<void> {
    await Excel.run(async (context) => {
      let settings = context.workbook.settings;
      settings.add(`Info_${syncSettings.activeSheetId}`, syncSettings.activeSheetName);
      settings.add(`Info_${syncSettings.activeSheetId}_EngagementId`, syncSettings.engagementId);
      settings.add(`Info_${syncSettings.activeSheetId}_NoOfRequests`, syncSettings.noOfRecordsDownloaded);
      settings.add(`Info_${syncSettings.activeSheetId}_DownloadedOn`, syncSettings.requestsDownloadedDate);
      settings.add(`Info_${syncSettings.activeSheetId}_RenderedOn`, syncSettings.requestsRenderedDate);
      settings.add(`Info_${syncSettings.activeSheetId}_UploadedOn`, syncSettings.requestUploadedDate);
      settings.add(
        `Info_${syncSettings.activeSheetId}_TimePhaseMasterMetaData`,
        syncSettings.timePhaseMasterMetaData
      );
      settings.add(`Info_${syncSettings.activeSheetId}_SelectedEntityType`, syncSettings.selectedEntityType);
      settings.add(`Info_${syncSettings.activeSheetId}_activeSheetId`, syncSettings.activeSheetId);
      settings.add(`Info_${syncSettings.activeSheetId}_EngagementIdAndDesc`, syncSettings.engagementIdAndDescription);
      settings.add(`Info_${syncSettings.activeSheetId}_UserLanguage`, syncSettings.userLanguage);
      settings.add(`Info_${syncSettings.activeSheetId}_ldcVersioning`, syncSettings.engagementLDCVersion);
      settings.add(`Info_${syncSettings.activeSheetId}_EntitySelected`, syncSettings.entitySelected);
      await ExcelHelper.tryCatchContextSync(
        context,
        `persisted the ServerSyncInfo settings for the engagement ${syncSettings.engagementId}`
      );
    });
  }

  public static async getPersistedServerSyncInfo(
    activeSheetId: string,
    activeSheetName: string
  ): Promise<ServerSyncInfoSettings> {
    let serverSyncSettings = new ServerSyncInfoSettings(activeSheetId, "");
    await ExcelHelper.tryCatchRunAsync(async (context) => {
      let settings = context.workbook.settings;
      let persistedEngagementIdSetting: Excel.Setting = settings.getItem(`Info_${activeSheetId}_EngagementId`);
      persistedEngagementIdSetting?.load();

      let noOfRequestsSetting: Excel.Setting = settings.getItem(`Info_${activeSheetId}_NoOfRequests`);
      noOfRequestsSetting?.load();

      let downloadedOnSetting: Excel.Setting = settings.getItem(`Info_${activeSheetId}_DownloadedOn`);
      downloadedOnSetting?.load();

      let renderedOnSetting: Excel.Setting = settings.getItem(`Info_${activeSheetId}_RenderedOn`);
      renderedOnSetting?.load();

      let uploadedOnSetting: Excel.Setting = settings.getItem(`Info_${activeSheetId}_UploadedOn`);
      uploadedOnSetting?.load();

      let selectedEntityTypeSetting: Excel.Setting = settings.getItem(`Info_${activeSheetId}_SelectedEntityType`);
      selectedEntityTypeSetting?.load();

      let engagementIdAndDescription: Excel.Setting = settings.getItem(`Info_${activeSheetId}_EngagementIdAndDesc`);
      engagementIdAndDescription?.load();

      let userLanguage: Excel.Setting = settings.getItem(`Info_${activeSheetId}_UserLanguage`);
      userLanguage?.load();

      let ldcVersioning: Excel.Setting = settings.getItem(`Info_${activeSheetId}_ldcVersioning`);
      ldcVersioning?.load();

      let entitySelected: Excel.Setting = settings.getItem(`Info_${activeSheetId}_EntitySelected`);
      entitySelected?.load();

      await ExcelHelper.tryCatchContextSync(
        context,
        `loaded the ServerSyncInfo settings for the engagement ${activeSheetId}`
      );

      console.log("loaded settings", persistedEngagementIdSetting.value);
      console.log("loaded settings", noOfRequestsSetting.value);
      console.log("loaded settings", downloadedOnSetting.value);
      console.log("loaded settings", renderedOnSetting?.value);
      console.log("loaded settings", uploadedOnSetting?.value);
      console.log("loaded settings", engagementIdAndDescription.value);
      
      if (!persistedEngagementIdSetting.isNullObject) {
        serverSyncSettings.engagementId = persistedEngagementIdSetting.value;
      }

      if (!noOfRequestsSetting.isNullObject) {
        serverSyncSettings.noOfRecordsDownloaded = noOfRequestsSetting.value;
      }

      if (!downloadedOnSetting.isNullObject) {
        serverSyncSettings.requestsDownloadedDate = downloadedOnSetting.value;
      }

      if (!renderedOnSetting.isNullObject) {
        serverSyncSettings.requestsRenderedDate = renderedOnSetting?.value;
      }

      if (!uploadedOnSetting.isNullObject) {
        serverSyncSettings.requestUploadedDate = uploadedOnSetting?.value;
      }

      if (!selectedEntityTypeSetting.isNullObject) {
        serverSyncSettings.selectedEntityType = selectedEntityTypeSetting.value;
      }
      
      if(!engagementIdAndDescription.isNullObject){
        serverSyncSettings.engagementIdAndDescription = engagementIdAndDescription.value;
      }

      if(!userLanguage.isNullObject){
        serverSyncSettings.userLanguage = userLanguage.value;
      }

      if(!ldcVersioning.isNullObject){
        serverSyncSettings.engagementLDCVersion = ldcVersioning.value;
      }

      if(!entitySelected.isNullObject){
        serverSyncSettings.entitySelected = entitySelected.value;
      }

      console.log("loaded settings after populated to syncInfo model", serverSyncSettings);
    }, `getPersistedServerSyncInfo settings for the engagement ${activeSheetId}`);
    return serverSyncSettings;
  }
}
